module.exports = __webpack_public_path__ + "static/media/IMG_4635.4ae41c3c.JPG";